import view from 'bz-stores/lib/diary-view-store';
import { action, observable } from 'mobx';
import Moment from 'moment';
import Api from 'tm3-core/api';

class StatsStore {
  @observable stats = new Map();
  @observable loading = false;
  @observable keys = [];

  @action.bound
  onLoad(keys) {
    this.keys = keys;
    if (keys.length < 1) {
      return;
    }

    this.loading = true;

    let end = new Moment(keys[keys.length - 1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');

    let request = {
      endDate: end,
      roomIds: view.rooms,
      startDate: keys[0],
      locationIds: view.location,
      practitionerIds: view.practitioners
    };

    let promise = new Promise((resolve, reject) => {
      Api.post('/api/diary/stats', request)
        .then((res) => {
          resolve(res.body);
        })
        .catch(() => resolve({}));
    });

    promise
      .then((res) => {
        this.stats.replace(res);
      })
      .catch(() => {
        this.stats.clear({});
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

export default new StatsStore();
